import React from 'react';
import { number, shape, node, bool, oneOf } from 'prop-types';
import { progressUnionTypes } from '@paddl/utils-js';
import { ActivityProgress } from '../../../../../..';
import { ProgressWrapper, ProgressStatus, ProgressStatusWrapper } from '../../../../../Activity.styles';
import { Duration } from '../../Duration';
export const TwoLineBlockProgress = _ref => {
  let {
    progressType,
    progressIndicatorStyles: {
      progressIndicatorColor,
      progressIndicatorCircleColor,
      icon,
      status
    },
    progress,
    duration: {
      startDate,
      endDate,
      timeStamp,
      isCurrent
    } = {},
    editButton
  } = _ref;
  return /*#__PURE__*/React.createElement(ProgressWrapper, null, editButton && editButton, /*#__PURE__*/React.createElement("h4", {
    className: "headline"
  }, "Progress"), /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/React.createElement(ActivityProgress, {
    progress: progress,
    progressIndicatorColor: progressIndicatorColor,
    progressIndicatorCircleColor: progressIndicatorCircleColor,
    icon: icon
  }), /*#__PURE__*/React.createElement(ProgressStatusWrapper, null, /*#__PURE__*/React.createElement(ProgressStatus, {
    color: progressIndicatorColor,
    className: "progress-status",
    "data-test-id": "progress-status"
  }, status), /*#__PURE__*/React.createElement("div", {
    className: "duration"
  }, /*#__PURE__*/React.createElement(Duration, {
    progressType: progressType,
    isCurrent: !!isCurrent,
    startDate: startDate,
    endDate: endDate,
    timeStamp: timeStamp
  })))));
};
TwoLineBlockProgress.propTypes = {
  progressType: oneOf(progressUnionTypes).isRequired,
  progressIndicatorStyles: shape({}).isRequired,
  progress: number.isRequired,
  duration: shape({
    startDate: shape({
      day: number,
      month: number,
      year: number
    }),
    endDate: shape({
      day: number,
      month: number,
      year: number
    }),
    isCurrent: bool
  }).isRequired,
  editButton: node
};
TwoLineBlockProgress.defaultProps = {
  editButton: undefined
};